import get from 'lodash/get';

export function fullProviderSubtitle(provider) {
  return [get(provider, 'specialization'), get(provider, 'organization.name')]
    .filter(str => !!str)
    .join(', ');
}

export function shortProviderSubtitle(provider) {
  return get(provider, 'organization.name');
}

export function transformProviderNameWithTitle(provider) {
  return {
    ...provider,
    name: [get(provider, 'name'), get(provider, 'title')]
      .filter(str => !!str)
      .join(', '),
  };
}



// WEBPACK FOOTER //
// ./src/utils/appointments/provider-details-formatter.js